
import Vue from "vue";
import KSelect from "@/components/crud/fields/KSelect.vue";

export default Vue.extend({
  name: "StockBatchStatusSelect",
  components: { KSelect },
});
